import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import './i18n';
import Gleap from 'gleap';

const theme=createMuiTheme({
	typography: {
		fontFamily:'"Work Sans",sans-serif'
	},
	overrides: {
		MuiOutlinedInput: {
			root: {
				"& $notchedOutline": {
					borderColor: "var(--type-q)"
				},
				"&:hover $notchedOutline": {
					borderColor: "var(--type-secondary)"
				},
				"&:disabled $notchedOutline": {
					borderColor: "var(--type-disabled)"
				},
				"&$focused $notchedOutline": {
					borderColor: "var(--theme-q)",
					legend: {
						color:  "var(--theme-q)"
					}
				},
				"&$error $notchedOutline": {
					borderColor: "var(--status-destructive-type)",
					legend: {
						color:  "var(--status-destructive-type)"
					}
				}
			}
		},
		MuiFormLabel: {
			root: {
				"&$focused": {
					color: "var(--theme-q)"
				},
				"&$error": {
					color: "var(--status-destructive-type)"
				}
			}
		}
	}
});
Gleap.initialize("cz344li5ucfLJ8vdvDYdRBOEJLAZC4XZ");

ReactDOM.render(
	<React.StrictMode>
		<Suspense fallback={null}>
			<ThemeProvider theme={theme}>
				<App />
			</ThemeProvider>
		</Suspense>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
